import React from "react";
import { useMutation } from "react-query";
import { _api_add_note } from ".";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";

const useMutationCreateExpense = () => {
    const navigate = useNavigate();

    const { mutate: mutate_add_note, isLoading: is_loading_adding_note } =
        useMutation(
            (data) => {
                // API function
                return _api_add_note({
                    name: data?.title,
                    reinvoiceable: data?.rebillable,
                    client_id: data?.client?.id,
                });
            },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        const route_detail = ROUTES.expenses.detail;
                        return navigate(
                            `${route_detail.custom_route(
                                route_detail.route,
                                data?.expense_report?.id
                            )}`
                        );
                    } else {
                        alert("Error when create the Expense Report !");
                    }
                },
            }
        );
    return {
        is_loading_adding_note,
        mutate_add_note,
    };
};

export default useMutationCreateExpense;
